if (document.readyState !== 'loading') {
	initHeader()
} else {
	document.addEventListener('DOMContentLoaded', initHeader)
}

var timeoutSetting = 500
window.navTimer = false
window.cartTimer = false

function initImageMouseOver(className) {
	document.querySelectorAll('.cHeader ' + className).forEach(function(el) {
		var target = document.querySelector('.cHeader .eTop ' + className)
		var targetText = document.querySelector('.cHeader .eBottom ' + className)
		target.setAttribute('data-off', target.src)

		el.addEventListener('mouseover', function(ev) {
			target.setAttribute('src', target.getAttribute('data-over'))
			targetText.classList.toggle('mActive')
		})
		el.addEventListener('mouseout', function(ev) {
			target.setAttribute('src', target.getAttribute('data-off'))
			targetText.classList.toggle('mActive')
		})
	})
}

function removeAllShades(includingShade) {
	// remove shade
	if (typeof includingShade == 'undefined') {
		document.querySelector('.cShade').classList.remove('mActive')
	}

	// remove cart popup
	document.getElementById('cart').classList.remove('open')

	// remove search bar
	document.querySelector('.cHeader .cSearchBar').classList.remove('mActive')

	// remove mega menus
	Array.from(document.querySelectorAll('.cHeader .cMegaMenu')).forEach(function(el) {
		el.classList.remove('mActive')
	})
}

function initHeader() {
	// image roll overs for header
	initImageMouseOver('.eStores')
	initImageMouseOver('.eFavoritesButton')
	initImageMouseOver('.eMeasure')
	initImageMouseOver('.eContact')
	initImageMouseOver('.eAccount')
	initImageMouseOver('.eCart')

	// popup cart
	Array.from(document.querySelectorAll('.cHeader .eCart')).forEach(function (el) {
		el.addEventListener('mouseover', function(ev) {
			window.clearTimeout(window.cartTimer)
			removeAllShades()
			document.getElementById('cart').classList.add('open')
		})

		el.addEventListener('mouseout', function(ev) {
			window.clearTimeout(window.cartTimer)
			window.cartTimer = window.setTimeout(function() {
				removeAllShades()
			}, timeoutSetting)
		})
	})

	// popup cart
	document.getElementById('cart').addEventListener('mouseover', function(ev) {
		window.clearTimeout(window.cartTimer)
		removeAllShades()
		document.getElementById('cart').classList.add('open')
	})

	// popup cart
	document.getElementById('cart').addEventListener('mouseout', function(ev) {
		window.clearTimeout(window.cartTimer)
		window.cartTimer = window.setTimeout(function() {
			removeAllShades()
		}, timeoutSetting)
	})

	// cart click through
	document.querySelector('.cHeader .eCart').addEventListener('click', function(ev) {
		window.location = '/cart';
	})

	// roll over search
	document.querySelector('.cHeader .eToggleSearch').addEventListener('mouseover', function(ev) {
		window.clearTimeout(window.cartTimer)

		removeAllShades(false)

		document.querySelector('.cHeader .cSearchBar').classList.add('mActive')
		document.querySelector('.cShade').classList.add('mActive')
	})

	document.querySelector('.cHeader .eToggleSearch').addEventListener('click', function(ev) {
		ev.preventDefault()
	})

	// add roll over states to search bar
	document.querySelector('.cHeader .cSearchBar').addEventListener('mouseover', function(ev) {
		window.clearTimeout(window.cartTimer)
	})

	document.querySelector('.cHeader .cSearchBar').addEventListener('mouseleave', function(ev) {
		window.clearTimeout(window.cartTimer)
		window.cartTimer = window.setTimeout(function() {
			removeAllShades()
		}, timeoutSetting)
	})

	// click on shade to remove it
	document.querySelector('.cShade').addEventListener('click', function(ev) {
		removeAllShades()
	})

	// add show hide mega menu on roll over
	document.querySelectorAll('[data-hover]').forEach(function(el) {
		var target = el.getAttribute('data-hover')

		el.addEventListener('mouseover', function(ev) {
			window.clearTimeout(window.cartTimer)

			removeAllShades(false)

			document.querySelector('.cHeader .cMegaMenu.'+target).classList.add('mActive')
			document.querySelector('.cShade').classList.add('mActive')
		})
	})

	// add roll over states to mega menu
	document.querySelectorAll('.cHeader .cMegaMenu').forEach(function(el) {
		el.addEventListener('mouseover', function(ev) {
			window.clearTimeout(window.cartTimer)
		})

		el.addEventListener('mouseleave', function(ev) {
			window.clearTimeout(window.cartTimer)
			window.cartTimer = window.setTimeout(function() {
				removeAllShades()
			}, timeoutSetting)
		})
	})

	// add roll over states to nav menu
	document.querySelector('.cHeader .eBottom nav').addEventListener('mouseover', function(ev) {
		window.clearTimeout(window.cartTimer)
	})

	document.querySelector('.cHeader .eBottom nav').addEventListener('mouseleave', function(ev) {
		window.clearTimeout(window.cartTimer)
		window.cartTimer = window.setTimeout(function() {
			removeAllShades()
		}, timeoutSetting)
	})

	// animate mobile menu
	document.querySelector('.cHeader .eTop .eMobile button').addEventListener('click', function(ev) {
		document.querySelector('.cHeader .eMenu').classList.toggle('mActive')
		document.querySelector('.cHeader .eTop .eMobile button .fal').classList.toggle('fa-bars')
		document.querySelector('.cHeader .eTop .eMobile button .fal').classList.toggle('fa-times')
	})

	// image popup on product
	Array.from(document.querySelectorAll('.cProduct .eMainSlider')).forEach(function(el) {
		el.addEventListener('click', function(ev) {
			if (ev.target.nodeName == 'IMG') {
				ev.preventDefault();
				document.querySelector('.cLightboxV2').classList.add('mActive')
				document.body.classList.add('mNoscroll')
				$('.cProduct .eLightboxSlider').slick('refresh');
			}
		})

		document.querySelector('.cLightboxV2').addEventListener('click', function(ev) {
			console.log(ev.target.nodeName)
			if (ev.target.nodeName == 'I' || ev.target.nodeName == 'DIV') {
				ev.preventDefault();
				$('.cProduct .eLightboxSlider').slick('refresh');
				document.querySelector('.cLightboxV2').classList.remove('mActive')
				document.body.classList.remove('mNoscroll')
			}
		})

		/*
		document.querySelector('.eLightbox img').addEventListener('click', function(ev) {
			document.querySelector('.eLightbox').classList.remove('mActive')
			document.body.classList.remove('mNoscroll')
		})
		*/
	})

	// category filter show / hide
	Array.from(document.querySelectorAll('[data-tab-target]')).forEach(function (el) {
		el.addEventListener('mouseover', function(ev) {
			Array.from(el.parentNode.querySelectorAll('[data-tab-target]')).forEach(function (li) {
				li.classList.remove('mActive')
			})

			target = document.getElementById(el.getAttribute('data-tab-target'))

			Array.from(target.parentNode.querySelectorAll('.eTab.mActive')).forEach(function (tab) {
				tab.classList.remove('mActive')
			})

			target.classList.add('mActive')
			el.classList.add('mActive')
		})
	})

	// category filter fix on mobile
	if (window.innerWidth <= 750) {
		if (document.getElementById('filters-container')) {
			document.getElementById('filters-container').classList.remove('in')
		}

		mobileIcons('.cHeader .eTop .eMobile .eStores')
		mobileIcons('.cHeader .eTop .eFavoritesButton')
		mobileIcons('.cHeader .eTop .eCart')
	}
}

function mobileIcons(selector) {
	document.querySelector(selector).setAttribute('src', document.querySelector(selector).getAttribute('data-over'))
}
